<template>
  <el-dialog
    v-if="visible"
    :visible="visible"
    show-close
    v-el-dialog-drag
    custom-class="feedback-dialog"
    width="900px"
    title="客服反馈"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close()"
  >
    <ServiceFeedbackIndex ref="serviceFeedbackIndex" :order="order" />
  </el-dialog>
</template>
<script>
import ServiceFeedbackIndex from './index'
export default {
  components: { ServiceFeedbackIndex },
  props: {
    visible: { type: Boolean, default: false },
    order: { type: Object, default: () => {} },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss">
.feedback-dialog {
  position: absolute !important;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: 0 auto !important;
  margin-top: 0 !important;
}
</style>
